var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.577,
    height: 13.261,
    viewBox: "0 0 16.577 13.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail_FILL0_wght400_GRAD0_opsz48",
    d: "M81.243,269.261A1.275,1.275,0,0,1,80,268.018V257.243A1.275,1.275,0,0,1,81.243,256h14.09a1.275,1.275,0,0,1,1.243,1.243v10.775a1.275,1.275,0,0,1-1.243,1.243ZM88.288,263l-7.045-4.621v9.635h14.09v-9.635Zm0-1.243,6.962-4.517h-13.9Zm-7.045-3.377v0Z",
    transform: "translate(-80 -256)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.efee27f6c7d1099c50002a308f577c6a.svg";
export { ForwardRef as ReactComponent };